module.exports = __webpack_public_path__ + "img/87.7.Chla.3f5779d2.png";